import * as Styled from './OrganizationOwners.styled';
import { useGetOrganizationOwners } from '@modules/organizations/api/useGetOrganizationOwners';

import { Spinner } from '@capra/core';
import { Row, Col, Button } from 'antd';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';
import { useState } from 'react';
import { Organization } from 'shared/src/organization/types';
import { Member } from 'shared/src/types';

const ModalTitle = ({ organization }: { organization: Organization }) => (
  <Row align='middle'>
    <Col>
      <Row>{`${organization?.organizationAlias || organization?.organizationId} Owners`}</Row>
    </Col>
  </Row>
);

interface IOrganizationOwnersProps {
  organization: Organization;
  handleCancel: React.MouseEventHandler<HTMLElement> | undefined;
}

export const OrganizationOwners: React.FC<IOrganizationOwnersProps> = ({
  organization,
  handleCancel,
}: {
  organization: Organization;
  handleCancel: React.MouseEventHandler<HTMLElement> | undefined;
}) => {
  const [filteredOwners, setFilteredOwners] = useState<Member[]>([]);
  const { data: owners } = useGetOrganizationOwners(organization.organizationId);

  React.useEffect(() => {
    if (owners) {
      setFilteredOwners(owners);
    }
  }, [owners]);

  const isLoadingOwners = !filteredOwners || !owners || owners.length === 0;
  const areOwnersLoaded = filteredOwners && owners && owners?.length > 0;

  const handleFilter = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const listOwners = (owners || [])?.filter(
      (x) => `${x.givenName} ${x.familyName}`.includes(e.target.value) || x.email?.includes(e.target.value),
    );
    setFilteredOwners(listOwners);
  };

  const getInitialsForOwner = (owner: Member): string => `${owner.givenName?.charAt(0)}${owner.familyName?.charAt(0)}`;

  return (
    <Styled.ModalGlobalStyle
      title={<ModalTitle organization={organization} />}
      open
      onCancel={handleCancel}
      onOk={handleCancel}
      footer={[
        <Button
          key='back'
          type='default'
          onClick={handleCancel}
        >
          Close
        </Button>,
      ]}
    >
      {isLoadingOwners && (
        <div>
          <Text>
            <Spinner
              size='sm'
              style={{ marginRight: 8 }}
            />{' '}
            Retrieving owners...
          </Text>
        </div>
      )}

      {areOwnersLoaded && (
        <>
          <Styled.StyledSearchInput
            placeholder='Filter'
            allowClear
            style={{ width: 250 }}
            prefix={<Styled.StyledFilterIcon />}
            onChange={handleFilter}
          />

          <div>
            {filteredOwners.map((owner) => (
              <div key={owner.userId}>
                <Styled.StyledContentRow align='middle'>
                  <Col>
                    <Styled.StyledMainPartRow>
                      <Col>
                        <Styled.StyledAvatar>{getInitialsForOwner(owner)}</Styled.StyledAvatar>
                      </Col>

                      <Col>
                        <Row>
                          <Styled.StyledName>
                            {owner.givenName} {owner.familyName}
                          </Styled.StyledName>
                        </Row>

                        <Row>
                          <Text>
                            <a href={`mailto:${owner.email}`}>{owner.email}</a>
                          </Text>
                        </Row>
                      </Col>
                    </Styled.StyledMainPartRow>
                  </Col>

                  <Col>
                    <Styled.StyledRole>{owner.roles?.length ? owner.roles[0] : ''}</Styled.StyledRole>
                  </Col>
                </Styled.StyledContentRow>
              </div>
            ))}
          </div>
        </>
      )}
    </Styled.ModalGlobalStyle>
  );
};
